import "./increase.css"
import Card from 'react-bootstrap/Card';
import { useState } from "react";
import { useEffect } from "react";

function Increase(){
      const [countone,setcountone]=useState(0);
        const [counttwo,setcounttwo]=useState(0);
        const [countthree,setcountthree]=useState(0);
        const [countfour,setcountfour]=useState(0);
        const [countfive,setcountfive]=useState(0);
        const [countsix,setcountsix]=useState(0);
        const [countseven,setcountseven]=useState(0);
        const [counteight,setcounteight]=useState(0);

        let targetone=20;
        let targettwo=5;
        let targetthree=3082;
        let targetfour=10;
        let targetfive=1500;
        let targetsix=98;
        let targetseven=35;
        let targeteight=15;
   useEffect(() => {
  let timer = setInterval(() => {
    if (window.scrollY >= 700) {
      setcountone((prev) => (prev >= targetone ? targetone : prev + 1));
      setcounttwo((prev) => (prev >= targettwo ? targettwo : prev + 1));
      setcountthree((prev) => (prev >= targetthree ? targetthree : prev + 1));
      setcountfour((prev) => (prev >= targetfour ? targetfour : prev + 1));
      setcountfive((prev) => (prev >= targetfive ? targetfive : prev + 1));
      setcountsix((prev) => (prev >= targetsix ? targetsix : prev + 1));
    setcountseven((prev) => (prev >= targetseven ? targetseven : prev + 1));
      setcounteight((prev) => (prev >= targeteight ? targeteight : prev + 1));

    }
  }, 100);

  return () => clearInterval(timer);
}, [targetone, targettwo, targetthree, targetfour, targetfive, targetsix,targetseven,targeteight]);

    return(
        <>
        <div className="increase">
           <div className="row">
    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-stethoscope me-2"></i> {/* Icon for departments/specialties */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{countone}</Card.Text>
                <Card.Text className="text-muted">
                    Medical Departments
                </Card.Text>
            </Card.Body>
        </Card>
    </div>

    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-user-md me-2"></i> {/* Icon for doctors/specialists */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{counttwo}</Card.Text>
                <Card.Text className="text-muted">
                    Specialized Doctors
                </Card.Text>
            </Card.Body>
        </Card>
    </div>

    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-users me-2"></i> {/* Icon for patients served */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{countthree}</Card.Text>
                <Card.Text className="text-muted">
                    Beneficiary Patients
                </Card.Text>
            </Card.Body>
        </Card>
    </div>

    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-calendar-check me-2"></i> {/* Icon for years of experience */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{countfour}</Card.Text>
                <Card.Text className="text-muted">
                    Years of Experience
                </Card.Text>
            </Card.Body>
        </Card>
    </div>
    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-procedures me-2"></i> {/* Icon for surgeries/procedures */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{countfive}</Card.Text>
                <Card.Text className="text-muted">
                    Successful Procedures
                </Card.Text>
            </Card.Body>
        </Card>
    </div>

    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-smile me-2"></i> {/* Icon for patient satisfaction */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{countsix}</Card.Text>
                <Card.Text className="text-muted">
                    Patient Satisfaction Rate
                </Card.Text>
            </Card.Body>
        </Card>
    </div>

    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-bed me-2"></i> {/* Icon for beds/rooms */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{countseven}</Card.Text>
                <Card.Text className="text-muted">
                    Modern Patient Rooms
                </Card.Text>
            </Card.Body>
        </Card>
    </div>

    <div className="col-md-4">
        <Card style={{ width: '100%' }}>
            <Card.Body>
                <Card.Title>
                    <i className="fas fa-award me-2"></i> {/* Icon for awards/recognition */}
                </Card.Title>
                <Card.Text className="display-5 fw-bold">{counteight}</Card.Text>
                <Card.Text className="text-muted">
                    Awards & Recognitions
                </Card.Text>
            </Card.Body>
        </Card>
    </div>
</div>
        </div>
        </>
    )
}
export default Increase